import React from "react";
import PublicStatisticsPage from "@src/reporting/pages/PublicStatisticsPage";

const displayPublicStatistics = () => ({
  uuid: "public-statistics",
  view: () => <PublicStatisticsPage />,
});

export const routes = [
  {
    path: "/",
    view: displayPublicStatistics,
  },
];

export default routes;
